import { createSelectorCreator, defaultMemoize } from 'reselect';
import { is, Map } from 'immutable';

const createImmutableSelector = createSelectorCreator(defaultMemoize, is);
let selector = {};

const getHomeId = (state, homeId) => homeId;

const getBoxByHomeId = (boxes, homeId) => {
    let homeBox = new Map();
    boxes.map(Box => {
        if (Box.get('homeId') === parseInt(homeId) && ['active', 'provisioned'].indexOf(Box.get('boxState')) !== -1) homeBox = Box;
    });
    return homeBox;
};
const getUsersByHomeId = (users, homeId) => {
    return users.filter(user => user.getIn(['homeId'], '').toString() === homeId);
};
const productsByHomeIdSelector = (products, homeId) => {
    return products.filter(Product => {
        return Product.getIn(['homeId'], '').toString() === homeId;
    });
};
const mergeBoxesInHomes = (Homes, Boxes) => {
    Boxes.map(Box => {
        if (Box.get('homeId') !== null && ['active', 'provisioned'].indexOf(Box.get('boxState')) !== -1 && Homes.has(Box.get('homeId').toString())) {
            Homes = Homes.mergeIn([Box.get('homeId').toString()], Box);
        }
    });
    return Homes;
};
const getBoxesArray = Boxes => {
    let boxesArray = [];
    Boxes.map((Box, key) => {
        if (Box.get('homeId') === null || ['nouvelle', 'inactive'].indexOf(Box.get('boxState')) !== -1)
            boxesArray.push({ mac: key, id: Box.get('boxId') });
    });

    return boxesArray;
};
const getManagementsArray = managements => {
    let managementsArray = [];
    managements.forEach((management, id) => {
        managementsArray.push({ value: parseInt(id), label: management.get('libelle') });
    });
    managementsArray.sort((a, b) => {
        const textA = a.label.toUpperCase();
        const textB = b.label.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    return managementsArray;
};

function Selector(_environment) {
    this.environment = _environment;
}

/*** SELECTORS Functions ***/
Selector.prototype.getHomesWithBoxes = function(...args) {
    return createImmutableSelector([this.getHomes.bind(this), this.getBoxes.bind(this)], mergeBoxesInHomes)(...args);
};
Selector.prototype.getBoxByHomeId = function(...args) {
    return createImmutableSelector([this.getBoxes.bind(this), getHomeId], getBoxByHomeId)(...args);
};
Selector.prototype.getUsersByHomeId = function(...args) {
    return createImmutableSelector([this.getUsers.bind(this), getHomeId], getUsersByHomeId)(...args);
};
Selector.prototype.getProductsByHomeId = function(...args) {
    return createImmutableSelector([this.getProducts.bind(this), getHomeId], productsByHomeIdSelector)(...args);
};
Selector.prototype.getBoxesArray = function(...args) {
    return createImmutableSelector([this.getBoxes.bind(this)], getBoxesArray)(...args);
};
Selector.prototype.getManagementsArray = function(...args) {
    return createImmutableSelector([this.getManagements.bind(this)], getManagementsArray)(...args);
};

/*** SELECTORS SIMPLES ***/
Selector.prototype.getHomeByHomeId = function(state, homeId) {
    return state.environments[this.environment].data.Homes.getIn(['list', homeId], new Map());
};
Selector.prototype.getProfile = function(state) {
    return state.data.user;
};
Selector.prototype.getInstallers = function(state) {
    return state.environments[this.environment].data.Installers.get('list');
};
Selector.prototype.getManagements = function(state) {
    return state.environments[this.environment].data.Managements.get('list');
};
Selector.prototype.getBrands = function(state) {
    return state.environments[this.environment].data.Brands.get('list');
};
Selector.prototype.getHistoryActions = function(state) {
    return state.environments[this.environment].data.Homes.get('historyActions');
};
Selector.prototype.getClientInterface = function(state) {
    return state.environments[this.environment].gitlabApi.get('clientInterface');
};
Selector.prototype.getSearchCityUrl = function(state) {
    return state.data.searchCityUrl;
};
Selector.prototype.getBoxes = function(state) {
    return state.environments[this.environment].data.Boxes.get('list');
};
Selector.prototype.getPrefixCenter = function(state) {
    return state.environments[this.environment].data.Boxes.get('prefixCenter');
};
Selector.prototype.getHomesInitialized = function(state) {
    return state.environments[this.environment].data.Homes.get('initialized');
};
Selector.prototype.getUsersInitialized = function(state) {
    return state.environments[this.environment].data.Users.get('initialized');
};
Selector.prototype.getProducts = function(state) {
    return state.environments[this.environment].data.Products.get('list');
};
Selector.prototype.getUsers = function(state) {
    return state.environments[this.environment].data.Users.get('list');
};
Selector.prototype.getHomes = function(state) {
    return state.environments[this.environment].data.Homes.get('list');
};
Selector.prototype.getCodeEnv = function(state) {
    return state.data.configEnvs.getIn([this.environment, 'code'], null);
};

export default function(environment) {
    if (!selector[environment]) {
        selector[environment] = new Selector(environment);
    }
    return selector[environment];
}



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/selectors.js